import { useState } from "react";
import { useRecoveryFileStore } from "../../../../stores/Utils/recoveryFIle";
import { useParams } from "react-router-dom";
import {
  requestReminderLate,
  requestReminderWaiting,
} from "../../../../services/Api/customerService";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";

const RelaunchPopup = ({ closeModal }: any) => {
  const {
    selectedIdsRequestDeadLine,
    setSelectedIdsRequestDeadLine,
    selectedIdsRequestInProgress,
    setSelectedIdsRequestInProgress,
    setSelectedAllDeadLine,
    setSelectedAllInProgress,
  } = useRecoveryFileStore();
  const [loading, setLoading] = useState<boolean>(false);
  const { idCustomer, idMission } = useParams();

  const handleRelaunchLate = () => {
    setLoading(true);
    if (idCustomer && idMission)
      requestReminderLate(
        parseInt(idCustomer),
        parseInt(idMission),
        selectedIdsRequestDeadLine
      )
        .then(() => {
          showToastSuccess("Relance envoyée avec succès");
          closeModal();
          setSelectedAllDeadLine(false);
          setSelectedAllInProgress(false);
          setLoading(false);
          setSelectedIdsRequestDeadLine([]);
        })
        .catch(() => {
          showToastError("Erreur lors de l'envoi de la relance");
          setLoading(false);
        });
  };

  const handleRelaunchWaiting = () => {
    setLoading(true);
    if (idCustomer && idMission)
      requestReminderWaiting(
        parseInt(idCustomer),
        parseInt(idMission),
        selectedIdsRequestInProgress
      )
        .then(() => {
          setLoading(false);
          showToastSuccess("Relance envoyée avec succès");
          closeModal();
          setSelectedAllDeadLine(false);
          setSelectedAllInProgress(false);
          setSelectedIdsRequestInProgress([]);
        })
        .catch(() => {
          showToastError("Erreur lors de l'envoi de la relance");
          setLoading(false);
        });
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
        <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[45%]">
          {/* Content */}
          <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full bg-white p-3 rounded-t-xl">
              <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                Relance
              </h4>
            </div>
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="flex flex-col justify-center items-center w-11/12 mb-6">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                  Confirmation de relance
                </h3>
                <p className="text-md text-gray-600 text-center">
                  Vous êtes sur le point d'envoyer un e-mail à chaque individu lié
                  aux requêtes que vous avez sélectionnées.
                </p>
                <p className="text-sm text-gray-500 text-center mt-2 italic">
                  Êtes-vous sûr de vouloir continuer ?
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-gray-200 cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
                type="button"
                onClick={() => closeModal()}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className={`px-4 py-2 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm ${
                  !loading
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                type="button"
                disabled={loading}
                onClick={() => {
                  if (selectedIdsRequestDeadLine.length > 0)
                    handleRelaunchLate();
                  if (selectedIdsRequestInProgress.length > 0)
                    handleRelaunchWaiting();
                }}
              >
                {!loading ? (
                  <>
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Valider
                  </>
                ) : (
                  <>
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-3.5 h-3.5 animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#1C64F2"
                      />
                    </svg>
                    Envoi...
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default RelaunchPopup;
